import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { postUpdateTargetValueEndpoint } from '../../../common/endpoints';

export const postUpdateTargetValue = createApi(postUpdateTargetValueEndpoint, 'POST');

const UpdateTargetValue = createSlice({
  name: 'UpdateTargetValue',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postUpdateTargetValue.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postUpdateTargetValue.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postUpdateTargetValue.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default UpdateTargetValue.reducer;